// extracted by mini-css-extract-plugin
export default {"step":"Steps_step_Ymb60","stepText":"Steps_stepText_hOBSP","stepTitle":"Steps_stepTitle_Nb1Bn","stepDate":"Steps_stepDate_jqjGR"};